var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12.75C4.25 11.6228 4.69777 10.5418 5.4948 9.7448C6.29183 8.94777 7.37283 8.5 8.5 8.5H42.5C43.6272 8.5 44.7082 8.94777 45.5052 9.7448C46.3022 10.5418 46.75 11.6228 46.75 12.75V38.25C46.75 39.3772 46.3022 40.4582 45.5052 41.2552C44.7082 42.0522 43.6272 42.5 42.5 42.5H8.5C7.37283 42.5 6.29183 42.0522 5.4948 41.2552C4.69777 40.4582 4.25 39.3772 4.25 38.25V12.75ZM11.7279 12.75L25.5 24.8009L39.2721 12.75H11.7279ZM42.5 15.5741L26.9004 29.2251C26.5129 29.5646 26.0152 29.7518 25.5 29.7518C24.9848 29.7518 24.4871 29.5646 24.0996 29.2251L8.5 15.5741V38.25H42.5V15.5741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.f6ce3dcc42c85f3070349b612f7359c0.svg";
export { ForwardRef as ReactComponent };